import {AuthState, AvatarSource, User, UserMinimal} from '@types';
import {Storage} from '@utils/storage';

export function replaceAvatarUrlWithTheme(
    url: string,
    theme: 'light' | 'dark'
): string {
    return theme === 'dark'
        ? url.replace(
              /avatar_placeholder(\d+)\.jpeg/,
              'avatar_placeholder$1_dark.jpeg'
          )
        : url;
}

export function get64UserProfileForUser(
    user: User | UserMinimal,
    theme: 'light' | 'dark' = 'light'
): string | undefined {
    const filteredSource = user?.avatar?.sources?.find(
        (source: AvatarSource) => source.size === 64
    );
    const url = filteredSource ? filteredSource.url : undefined;
    return url ? replaceAvatarUrlWithTheme(url, theme) : url;
}

export function getUserLocale(): string {
    const authObj = Storage.getObjData<AuthState>('auth');
    const user = authObj?.user;
    return user?.language || navigator?.language || 'en-US';
}
